export const TemplateFieldsLibrary = {
  tabs: [
    {
      entry: { key: 'header1', label: '' },
      children: [
        { entry: { key: 'name', type: 'text', controlType: 'textbox', label: 'LIBRARY.FIELDS.SUBJECT', required: true, validationMessage: 'LIBRARY.VALIDATION.SUBJECT' }},
        { entry: { key: 'description', controlType: 'text', label: 'LIBRARY.FIELDS.DESCRIPTION'}}
      ]
    }
  ]
};
